// extracted by mini-css-extract-plugin
module.exports = {"tablet":"680px","laptop":"980px","desktop":"1180px","module":"spacing_module__4lG_P","section":"spacing_section__DSFuN"};